import classNames from 'classnames';
import { useDropzone } from 'react-dropzone';
import { FC } from 'react';
import styles from './FileUploadArea.module.scss';

interface FileUploadAreaProps {
  onFileSelect: (file: File) => void;
  error?: string;
}

export const FileUploadArea: FC<FileUploadAreaProps> = ({ onFileSelect, error }) => {
  const onDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles[0]) {
      onFileSelect(acceptedFiles[0]);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'application/vnd.ms-excel': [],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
    },
  });

  return (
    <div>
      <div
        className={classNames(styles.upload, isDragActive && styles.upload_active)}
        {...getRootProps()}>
        <input {...getInputProps()} />
        <p className={styles.upload_title}>
          Перетащите или <span className={styles.link}>загрузите файл</span>
        </p>
        <p className={styles.upload_subtitle}>Файлы .XLSX, до 500 Кбайт</p>
      </div>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};
